import sendReportsRoutes from "./sendReportsRoutes";

export default [
    {
        path: "send-reports",
        name: "SendReports",
        component: () =>
            import(
                /* webpackChunkName: "loyaltyHome" */ "@/views/supplierPanel/sendReports/SendReports.vue"
            ),
        children: sendReportsRoutes
    },

    {
        path: "gifts",
        name: "Gifts",
        component: () =>
            import(
                /* webpackChunkName: "branchDebt" */ "@/views/supplierPanel/Gifts.vue"
            )
    },

    {
        path: "supplier-data",
        name: "Supplier-Data",
        component: () =>
            import(
                /* webpackChunkName: "branchDebt" */ "@/views/supplierPanel/Settings.vue"
            )
    }
];
